import { themeOptionFactories } from "./theme"

// Mobile pages
import { HomePage } from "./pages/home"

export const oneSiamLandingPage = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      /**
       * Page Routes (mobile)
       */
      { type: "base", index: true, element: <HomePage /> },
    ],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
